"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { ChevronLeft, XThin } from "@nxt-costco-com/forge-icons";
import { Text } from "../../../DataDisplay/Text/index.js";
import { IconButtonV2 } from "../../../Inputs/IconButtonV2/index.js";
import { Divider } from "../../Divider/index.js";
import { HeaderContainer, HeadingWrapper, TitleAndIconWrapper, IconWrapper, ChildrenWrapper } from "./styles.js";
import { BACK_BUTTON_ID, ICON_SIZE, TITLE_ID, CLOSE_BUTTON_ID, HEADER_ID } from "../constants.js";
import { listMissingVariables, getDataTestId } from "../../../Util/index.js";
const DrawerHeader = forwardRef(
  ({
    title,
    titleBold = true,
    titleSx = {},
    Icon,
    iconTitle,
    iconWrapperSx = {},
    onClose,
    closeButtonAriaLabel,
    level = 0,
    onBack,
    backButtonAriaLabel,
    children,
    headerSx = {},
    uniqueId
  }, ref) => {
    const missingProps = listMissingVariables({
      onClose,
      closeButtonAriaLabel,
      ...level > 0 ? { onBack, backButtonAriaLabel } : {}
    });
    if ((missingProps == null ? void 0 : missingProps.length) > 0) {
      console.error(`Missing props: ${missingProps}}`);
      return null;
    }
    const showBackButton = level > 0 && onBack && backButtonAriaLabel;
    const hasTitleOrIcon = title || Icon;
    return /* @__PURE__ */ jsxs(
      HeaderContainer,
      {
        ref,
        "data-testid": getDataTestId(HEADER_ID, uniqueId),
        children: [
          /* @__PURE__ */ jsxs(
            HeadingWrapper,
            {
              sx: headerSx,
              level,
              hasTitleOrIcon: Boolean(hasTitleOrIcon),
              children: [
                showBackButton && /* @__PURE__ */ jsx(
                  IconButtonV2,
                  {
                    "aria-label": backButtonAriaLabel,
                    uniqueId: BACK_BUTTON_ID,
                    onClick: onBack,
                    title: void 0,
                    children: /* @__PURE__ */ jsx(
                      ChevronLeft,
                      {
                        sx: {
                          color: ColorGray900
                        }
                      }
                    )
                  }
                ),
                hasTitleOrIcon && /* @__PURE__ */ jsxs(TitleAndIconWrapper, { children: [
                  Icon && /* @__PURE__ */ jsx(IconWrapper, { sx: iconWrapperSx, children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      "data-testid": "drawerheader_icon",
                      titleAccess: iconTitle,
                      sx: {
                        height: ICON_SIZE,
                        width: ICON_SIZE
                      }
                    }
                  ) }),
                  title && (typeof title === "string" ? /* @__PURE__ */ jsx(
                    Text,
                    {
                      component: "h2",
                      id: TITLE_ID,
                      bold: titleBold,
                      variant: "t4",
                      uniqueId: `drawerheader_title_${TITLE_ID}`,
                      sx: titleSx,
                      children: title
                    }
                  ) : title)
                ] }),
                /* @__PURE__ */ jsx(
                  IconButtonV2,
                  {
                    "aria-label": closeButtonAriaLabel,
                    uniqueId: CLOSE_BUTTON_ID,
                    onClick: (e) => onClose == null ? void 0 : onClose(e, "escapeKeyDown"),
                    title: void 0,
                    children: /* @__PURE__ */ jsx(
                      XThin,
                      {
                        sx: {
                          color: ColorGray900
                        }
                      }
                    )
                  }
                )
              ]
            }
          ),
          children && /* @__PURE__ */ jsx(ChildrenWrapper, { children }),
          hasTitleOrIcon && /* @__PURE__ */ jsx(Divider, {})
        ]
      }
    );
  }
);
DrawerHeader.displayName = "DrawerHeader";
export {
  DrawerHeader
};
